import { Link, useParams, useSubmit } from "react-router-dom";
import { useStateContext } from "state";
import {AudiencesZeroState} from "./audiences-zero-state.tsx";
import 'features/ad-hoc-audiences/audiences.page.scss'
import { FaChevronLeft } from "react-icons/fa";
import { useProject } from "hooks/projects";
import paths from "paths";


export function AudiencesPage() {
    const { user } = useStateContext();
    const { projectId, id } = useParams();

    const accountNumber = user?.isSingleAdHocAccount ?
        parseInt(user.roles[0].accountNumber) :
        parseInt(id!)

    const { data: project, isFetching: isProjectFetching, isError: isProjectError, isLoading } = useProject(accountNumber, parseInt(projectId!), {params: {expand: "audiences"}})

    const audiences = (project?.audiences ?? []);

    return (
        <div className="audiences-page">
            {isLoading ? null : (audiences.length === 0 ? <AudiencesZeroState/> : null)}
        </div>
    )
}